import styled from 'styled-components';

export const Container = styled.div`
  color: #1b2a20;
  /* a foto subiu para a Capa: o bloco fica branco, com texto escuro */
  background-color: #fff;
  padding-bottom: 10rem;
  padding-top: 5rem;
`;

export const ContentBannersBox = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: 48.813rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
  
  p,
  img {
    text-align: justify;
    font-size: 1rem;
    padding: 1.5rem;
    color: rgb(255, 255, 255,0.9);
  }
  img {
    width: 100%;
    border-radius: 0.625rem;
    
    @media only screen and (min-width: 600px) {
      display: none;
    }
  }
  `;

export const TRRSection = styled.section`
  padding: 4rem 1rem 0 1rem;
  background: #f9fafb; /* bg-gray-50 */
  `;


export const Title = styled.h2`
  text-align: center;
  font-size: 1.75rem; /* text-2xl */
  font-weight: 800;
  color: #065f46; /* green-800-ish */
  margin-bottom: 5rem;
`;

export const TRRGrid = styled.div`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr;
  margin: 0 10rem 0 10rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr); /* md:grid-cols-2 */
  }
`;

export const TRRColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem; /* space-y-6 */
`;

export const TRRItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem; /* space-x-4 */
  padding: 1rem;
`;

export const IconWrap = styled.div`
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  border-radius: 999px;
  background: #dcfce7; /* green-100 */
  color: #16a34a; /* green-600 */
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemTitle = styled.h3`
font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937; /* gray-800 */
  margin: 0 0 0.25rem 0;
`;

export const ItemText = styled.p`
  color: #4b5563; /* gray-600 */
  margin: 0;
  line-height: 1.6;
  font-size: 0.9rem;
`;